module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }